import { VIDEO_EVENTS } from 'playable';
export class VimeoWrapper {
  constructor(player) {
    this.player = player;
  }
  on(event, cb) {
    switch (event) {
      case VIDEO_EVENTS.CURRENT_TIME_UPDATED:
        this.onTimeUpdate(cb);
        break;
      case VIDEO_EVENTS.ERROR:
        this.onErrorHandler(cb);
        break;
      default:
        throw new Error(`event ${event} not supported`);
    }
    return this;
  }
  onTimeUpdate(cb) {
    this.player.on('timeupdate', cb);
  }
  onErrorHandler(cb) {
    this.player.on('error', cb);
  }
}
//# sourceMappingURL=VimeoWrapper.js.map